exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-menu a.dropdown-toggle:hover,\n.user-menu a.dropdown-toggle:active,\n.user-menu a.dropdown-toggle:focus {\n  background-color: transparent;\n}\n.user-menu i {\n  font-size: 10px;\n}\n.user-menu div[uib-dropdown] > a {\n  font-weight: 200;\n  position: relative;\n  display: block;\n  text-decoration: none;\n}\n@media (max-width: 992px) {\n  .user-menu div[uib-dropdown] > a {\n    padding: 10px;\n  }\n}\n@media (min-width: 992px) {\n  .user-menu div[uib-dropdown] > a {\n    padding: 5px 0;\n  }\n}\n.user-menu div[uib-dropdown] > a i.glyphicon {\n  position: relative;\n  top: 1px;\n  left: 2px;\n  font-size: 8px;\n}\n.user-menu div[uib-dropdown] .dropdown-menu {\n  top: 80%;\n  min-width: 125px;\n  border: 0;\n}\n@media (max-width: 480px) {\n  .user-menu div[uib-dropdown] .dropdown-menu {\n    position: static;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/authentication/userMenu/userMenu.less
// module id = 2838
// module chunks = 0